import FilaCliente from "./FilaCliente";

const COLORES_BG = {
  verde: "#d4edda",
  amarillo: "#fff3cd",
  rojo: "#f8d7da",
};

const BORDER = "1px solid #999";

const CELL_WRAP = {
  whiteSpace: "normal",
  wordWrap: "break-word",
  overflowWrap: "break-word",
  wordBreak: "break-word",
  overflow: "hidden",
};

const FilaCategoria = ({ categoria, maxContactos }) => {
  const subcategorias = categoria.subcategorias || [];

  return (
    <div
      style={{
        borderRadius: 12,
        overflow: "hidden",
        marginBottom: 16,
        border: "1px solid #ccc",
        boxShadow: "0 1px 4px rgba(0,0,0,.08)",
      }}
    >
      <table
        className="table table-sm align-middle mb-0"
        style={{ fontSize: ".85rem", borderCollapse: "collapse", tableLayout: "fixed", width: "100%" }}
      >
        <colgroup>
          <col style={{ width: "12%" }} />
          <col style={{ width: "12%" }} />
          <col style={{ width: "10%" }} />
          {Array.from({ length: maxContactos }, (_, i) => (
            <col key={i} style={{ width: `${66 / maxContactos}%` }} />
          ))}
        </colgroup>
        <tbody>
          {subcategorias.map((sub) =>
            (sub.marcas || []).map((marca, marcaIdx) => {
              const marcaRows = marca.productos.length * 2;

              // Si todos los productos de esta marca tienen producto === empresa (o sin producto),
              // fusionar marca+producto en una sola celda con colSpan=2
              const productoEsEmpresa = marca.productos.every((p) => !p.producto || p.producto === p.empresa);

              return marca.productos.map((prod, prodIdx) => {
                const isFirstProd = prodIdx === 0;

                return (
                  <FilaCliente
                    key={prod.id || `${subIdx}-${marcaIdx}-${prodIdx}`}
                    cli={prod}
                    maxContactos={maxContactos}
                    productoEsEmpresa={productoEsEmpresa}
                    marcaCell={
                      isFirstProd ? (
                        <td
                          rowSpan={marcaRows}
                          colSpan={productoEsEmpresa ? 2 : 1}
                          className="align-middle fw-medium"
                          style={{
                            ...CELL_WRAP,
                            backgroundColor: COLORES_BG[marca.color],
                            verticalAlign: "middle",
                            textAlign: "left",
                            border: BORDER,
                            fontSize: ".83rem",
                            padding: "6px 8px",
                          }}
                        >
                          {marca.nombre}
                        </td>
                      ) : null
                    }
                  />
                );
              });
            })
          )}
        </tbody>
      </table>
    </div>
  );
};

export default FilaCategoria;
